import * as React from "react";
import { forwardRef } from "react";
const SvgCloseToastIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3.75 9.75H14.25V8.25H3.75V9.75ZM2.25 12.75H12.75V11.25H2.25V12.75ZM5.25 5.25V6.75H15.75V5.25H5.25Z", fill: "black" }));
const ForwardRef = forwardRef(SvgCloseToastIcon);
export default ForwardRef;
